  <ng-container *ngIf="datoSlider!=undefined">
    <div class="postSlider mat-elevation-z2 cardBac animated slideInRight delay-1s">
      <div class="splide splide_galeria" role="group">
        <div class="splide__track">
          <div class="splide__list">
            <div class="splide__slide slidePost" fxLayout="column" fxLayoutAlign="space-between stretch" *ngFor="let post of datoSlider.posts" style="background-image: url({{post.imagen}})">
              <h2>{{post.category[idiomaActual]}}</h2>
              <span>{{post.title[idiomaActual]}}</span>
              <p class="linkPost">
                <a href="{{post.url}}" target="_blank">{{post.textUrl}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- <ng-container *ngIf="datoSlider2!=undefined">
    <div class="postSlider mat-elevation-z2 cardBac animated slideInRight delay-1s">
      <div class="splideV2" role="group">
        <div class="splide__track">
          <div class="splide__list">
            <div class="splide__slide slidePost" fxLayout="column" fxLayoutAlign="space-between stretch" *ngFor="let post of datoSlider2.posts" style="background-image: url({{post.imagen}})">
              <h2>{{post.category[idiomaActual]}}</h2>
              <span>{{post.title[idiomaActual]}}</span>
              <p class="linkPost">
                <a href="{{post.url}}" target="_blank">Leer post...</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container> -->
